export const bestSellers = [
  {
    name: "Jordan 1 Retro High",
    category: "Shoes",
    seller: "TopSneaker Yupoo",
    price: "$55",
    rating: "4.9",
    image: "https://readdy.ai/api/search-image?query=White%20and%20varsity%20red%20Jordan%201%20Retro%20High%20sneaker%20displayed%20at%20dynamic%20angle%20on%20light%20concrete%20surface%20dramatic%20side%20lighting%20editorial%20sneaker%20photography%20bold%20composition%20street%20style%20vibe%20high%20contrast%20clean%20background&width=600&height=600&seq=bs-jordan-v2&orientation=squarish"
  },
  {
    name: "Nike Dunk Low Panda",
    category: "Shoes",
    seller: "SneakerHub Store",
    price: "$48",
    rating: "4.8",
    image: "https://readdy.ai/api/search-image?query=Black%20and%20white%20Nike%20Dunk%20Low%20Panda%20sneaker%20top%20down%20view%20on%20raw%20cream%20canvas%20fabric%20soft%20overhead%20lighting%20editorial%20footwear%20photography%20minimal%20composition%20clean%20product%20display%20urban%20style&width=600&height=600&seq=bs-dunk-v2&orientation=squarish"
  },
  {
    name: "Essentials Hoodie",
    category: "Hoodies & Sweaters",
    seller: "StreetWear Direct",
    price: "$42",
    rating: "4.9",
    image: "https://readdy.ai/api/search-image?query=Heathered%20oatmeal%20color%20oversized%20hoodie%20laid%20flat%20on%20light%20warm%20wood%20floor%20morning%20sunlight%20streaming%20through%20window%20editorial%20streetwear%20photography%20cozy%20minimal%20aesthetic%20clean%20composition%20textile%20texture%20visible&width=600&height=600&seq=bs-hoodie-v2&orientation=squarish"
  },
  {
    name: "Nike Tech Fleece Set",
    category: "Sets",
    seller: "SportStyle Yupoo",
    price: "$65",
    rating: "4.7",
    image: "https://readdy.ai/api/search-image?query=Nike%20tech%20fleece%20jogger%20and%20hoodie%20set%20in%20charcoal%20grey%20artfully%20draped%20on%20minimal%20cream%20backdrop%20soft%20studio%20lighting%20editorial%20activewear%20photography%20clean%20sporty%20composition%20modern%20athletic%20aesthetic&width=600&height=600&seq=bs-fleece-v2&orientation=squarish"
  },
  {
    name: "LV Monogram Tote Bag",
    category: "Bags",
    seller: "LuxuryBag Gallery",
    price: "$89",
    rating: "4.8",
    image: "https://readdy.ai/api/search-image?query=Classic%20brown%20monogram%20canvas%20tote%20bag%20standing%20upright%20on%20cream%20marble%20surface%20elegant%20side%20lighting%20with%20soft%20shadows%20editorial%20luxury%20handbag%20photography%20minimal%20sophisticated%20composition%20high%20end%20fashion&width=600&height=600&seq=bs-bag-v2&orientation=squarish"
  },
  {
    name: "Supreme Box Logo Tee",
    category: "T-Shirts",
    seller: "HypeWear Co",
    price: "$28",
    rating: "4.6",
    image: "https://readdy.ai/api/search-image?query=White%20t-shirt%20with%20bold%20red%20box%20logo%20graphic%20flat%20lay%20on%20textured%20beige%20paper%20background%20bright%20natural%20lighting%20editorial%20streetwear%20photography%20minimal%20clean%20composition%20modern%20hype%20culture%20aesthetic&width=600&height=600&seq=bs-supreme-v2&orientation=squarish"
  }
];